import React from "react";
import { TrialBalancePeriod } from "../../../common/contracts/accounting-reports";
import { DataTableRow } from "../../general/DataTable/DataTableRow";
import { DataTableCell } from "../../general/DataTable/DataTableCell";
import { BreakableText } from "../../general/BreakableText/BreakableText";
import { ReportWithNestedGroupsRowLine } from "../../../common/types/reports/types";
import { TrialBalanceTableValueCell } from "./TrialBalanceTableValueCell";

interface Props {
    isSummary?: boolean;
    row: ReportWithNestedGroupsRowLine;
    periods: TrialBalancePeriod[];
}

export const TrialBalanceTableRow: React.FC<Props> = ({
    row,
    isSummary,
    periods,
}) => (
    <DataTableRow isSummary={isSummary}>
        <DataTableCell className="d-flex" isTitle>
            <BreakableText text={row.label} />
        </DataTableCell>
        {row.values.map((value, innerIndex) => {
            const period = periods[Math.floor(innerIndex / 2)];
            return (
                <TrialBalanceTableValueCell
                    key={period.label}
                    period={period}
                    isSummary={isSummary}
                    value={value}
                    accountCode={row.key}
                />
            );
        })}
    </DataTableRow>
);
